export function getQueryString(params: { [key: string]: number | string | undefined | null }) {
    var esc = encodeURIComponent;
    return Object.keys(params)
        .map(k => {
            const val = params[k];
            if (val) {
                return esc(k) + '=' + esc(val.toString());
            }
            return undefined;
        })
        .filter(Boolean)
        .join('&');
}

export function getQueryParamVal(queryString: string, param: string) {
    if (!queryString || !queryString.length || !param || !param.length) {
        return null;
    }

    let formattedQueryString = queryString;
    const sepIdx = queryString.indexOf('?');

    if (sepIdx !== -1) {
        formattedQueryString = queryString.slice(sepIdx + 1);
    }

    const result = [];
    const keyValPairs = formattedQueryString.split('&');
    let idx;

    for (idx in keyValPairs) {
        const [key, val] = keyValPairs[idx].split('=');
        if (!key.length || key !== param || !val) continue;
        result.push(val);
    }

    if (!result.length) {
        return null;
    }

    return result;
}
